import { Family } from './family.model';

export class Subfamily {
  id?: number;

  family_id?: number;

  label?: string;
  family?: Family;

  constructor(data = {}) {
    Object.assign(this, data);

    if (this.family) { this.family = new Family(this.family); }
  }
}
